import NotificationTypeEnum from '@constants/enums/notification/type';

import ReportApi from '@packages/reports/api';

import i18n from '@plugins/i18n';

import { Collection, Notification } from '@/models';

export class NotificationReportCollection extends Collection {
    static type = 'NotificationReportCollection';
    static endpoint = new ReportApi().methods.getNotifications;
    static model = Notification;

    static fields() {
        return {
            ...super.fields(),
            user_id: this.string(null).nullable()
        };
    }

    get default_headers() {
        return ['user_name', 'notification', 'type', 'event_at', 'created_at', 'viewed_at', 'deleted_at'];
    }

    get xlsx_headers() {
        return [
            'user_name',
            'user_email',
            'title',
            'body',
            'type',
            'event_at',
            'created_at',
            'viewed_at',
            'deleted_at'
        ];
    }

    get preset_filters() {
        let filters = {};

        if (this.user_id) {
            filters.user_id = this.filterOperator('is') + ':' + this.user_id;
        }

        return filters;
    }

    get headers() {
        return [
            this.createHeader('user_name', i18n.t('user'), {
                filterable: false,
                path: 'user.name',
                width: '18rem'
            }),
            this.createHeader('user_email', i18n.t('user_email'), {
                filterable: false,
                path: 'user.email',
                width: '18rem'
            }),
            this.createHeader('adviser_id', i18n.t('adviser'), {
                active: false,
                filterable: {
                    operators: this.getOperators(['eq']),
                    component: () => import('@/components/fields/Adviser.vue')
                }
            }),
            this.createHeader('notification', i18n.t('notification'), {
                filterable: false,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('title', i18n.t('title'), {
                filterable: true,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('body', i18n.t('body'), {
                width: '18rem',
                classList: ['clamp-2'],
                filterable: {
                    operators: this.getOperators(['contains', 'not_contains', 'starts_with', 'ends_with'])
                }
            }),
            this.createHeader('type', i18n.t('type'), {
                filterable: true,
                width: '16rem',
                format: 'enum',
                enum: NotificationTypeEnum,
                enumA11yKey: 'enums.notification_type'
            }),
            this.createHeader('event_at', i18n.t('event_at'), {
                filterable: true,
                width: '8rem',
                format: 'datetime',
                formatOptions: {
                    showTime: true
                }
            }),
            this.createHeader('created_at', i18n.t('date_created'), {
                filterable: true,
                width: '8rem',
                format: 'datetime',
                formatOptions: {
                    showTime: true
                }
            }),
            this.createHeader('viewed_at', i18n.t('date_viewed'), {
                filterable: true,
                width: '8rem',
                format: 'datetime',
                formatOptions: {
                    showTime: true
                }
            }),
            this.createHeader('deleted_at', i18n.t('date_deleted'), {
                filterable: true,
                width: '8rem',
                format: 'datetime',
                formatOptions: {
                    showTime: true
                }
            })
        ];
    }
}

export default NotificationReportCollection;
